import React from 'react';

// Hooks
import { useTranslation } from '@shopee-user/platform';

// Components
import {
  ButtonProps,
  ButtonLogoutProps,
  ButtonLoginProps,
} from '@shopee-user/business-customization-types';

// Utils
import cx from 'classnames';

import styles from './style.scss';

export default function Button({
  className,
  text,
  textClassName,
  icon,
  onClick,
  disabled,
  variant,
  type,
}: ButtonProps) {
  return (
    <button
      className={cx(
        className,
        styles.button,
        variant === 'wireframe' ? styles.wireframe : styles.solid
      )}
      onClick={onClick}
      disabled={disabled}
      type={type || 'button'}
    >
      {icon}
      <div
        className={cx(styles.text, icon && styles.textWithIcon, textClassName)}
      >
        {text}
      </div>
    </button>
  );
}

export function ButtonLogout({ text, onClick }: ButtonLogoutProps) {
  return (
    <button className={cx(styles.button, styles.logout)} onClick={onClick}>
      {text}
    </button>
  );
}

export function ButtonLogin(props: ButtonLoginProps) {
  const I18n = useTranslation();

  return (
    <Button
      {...props}
      className={styles.login}
      text={I18n.t('label_auth_next')}
    />
  );
}
